import { render, staticRenderFns } from "./coming-soon.vue?vue&type=template&id=24db6423&scoped=true"
import script from "./coming-soon.vue?vue&type=script&lang=js"
export * from "./coming-soon.vue?vue&type=script&lang=js"
import style0 from "./coming-soon.vue?vue&type=style&index=0&id=24db6423&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db6423",
  null
  
)

export default component.exports